import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Cookies from 'js-cookie';
import moment from 'moment';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Col, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useParams } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';

// Own constants/actions/components
import { items } from 'services/selectors/shopping-cart';
import { addItemsShoppingCartAction, deleteItemToShoopingCartById } from 'services/actions/shopping-cart';
import { resetExclusivitiesAction } from 'services/actions/exclusivity-experience-remove.js';
import CardStockComp from 'components/card-stock';
import ModalExclusivity from 'components/modal-exclusivity-experience';
import ModalCheck from 'components/modal-check';
import { setId } from 'helpers/random-id';
import { scrollEvent } from 'helpers/scroll-event';
import { hasExclusiveConflict } from 'helpers/exclusivity';

const TypeFaceToFace = (props) => {
  const { details, points, optionValue, cards } = props;
  const {
    id,
    title,
    image,
    type,
    startDelivery,
    menuIncludedList,
    numberOfPeople,
    location,
    duration,
    stock,
    exclusivity,
  } = details;
  const stockValidation = stock !== null ? stock : 99;
  const [options, setOptions] = useState([]);
  const [optionDef, setOptionDef] = useState('');
  const [flag, setFlag] = useState(false);
  const [count, setCount] = useState('');
  const [selectName, setSelectName] = useState('');
  const [isCheckedYouMustKnow, setIsCheckedYouMustKnow] = useState(false);
  const { id: pathId, pathName } = useParams();
  const dispatch = useDispatch();
  const { register, setValue, handleSubmit, formState: { errors }, setFocus, clearErrors } = useForm({ mode: 'onChange' });
  const [show, setShow] = useState(false);
  const handleOpen = () => setShow(true);
  const handleClose = () => setShow(false);
  const itemsCart = useSelector(items);
  const sessionActive = Cookies.get('frontSession') !== undefined;
  const [dataItemActual, setDataItemActual] = useState([]);

  const onSubmit = (dataform) => {
    for (let i = 0; i < dataform.count; i += 1) {
      /* eslint-disable */
      const newObjSend = Object.assign({}, dataform, {
        id: setId(),
        experienceId: id,
        title: title,
        image: image,
        delivery: moment(dataform.startDelivery).format('DD/MM/YYYY'),
        type: type.constant,
        typeName: type.name,
        points: points,
        isGift: false,
        useCrisData: false,
        notes: "",
        membersList: [],
        duration: duration,
        location: location,
        numberOfPeople: numberOfPeople,
        menuSelectedName: selectName,
        exclusivity: exclusivity,
        stock: stock,
        youShouldKnowCheck: true,
      });
      setDataItemActual([newObjSend]);
      dispatch(addItemsShoppingCartAction(newObjSend));
    }
    handleOpen();
  };

  const handlePlus = () => {
    setFocus('startDelivery');
    setFocus('selectedMenuId');
    setFocus('count');
    if (count < stockValidation) {
      setCount(Number(count) + 1);
      clearErrors(['count']);
    }
  };

  const handleLess = () => {
    setFocus('startDelivery');
    setFocus('selectedMenuId');
    setFocus('count');
    if (count > 0) {
      setCount(Number(count) - 1);
    }
    if( count-1 <= stockValidation ) {
      clearErrors(['count']);
    }
  };

  const removeAutoExclusivity = (indexExpRemove) => {
    dispatch(deleteItemToShoopingCartById(indexExpRemove));
    dispatch(resetExclusivitiesAction());
  };

  const modalShowCases = () => {
    if (hasExclusiveConflict(dataItemActual, cards)) {
      return (
        <ModalExclusivity
          stateInitial={show}
          close={handleClose}
          itemsCart={dataItemActual}
          removeFunc={removeAutoExclusivity}
          path="mis-experiencias" />
      );
    }

    return (
      <ModalCheck
        stateInitial={show}
        close={handleClose}
        itemsCart={dataItemActual}
        path="mis-experiencias" />
    );
  };

  useEffect(() => {
    scrollEvent();
    setOptions(menuIncludedList);
    if (optionValue)  {
      setFlag(true);
      setValue('selectedMenuId', optionValue);
      setSelectName(menuIncludedList.find(menu => menu.id === Number(optionValue)).title.replace(':', ''));
    } else {
      setValue('selectedMenuId', menuIncludedList.length === 1 ? menuIncludedList[0].id : '');
      setSelectName(menuIncludedList.length === 1 ? menuIncludedList[0].title.replace(':', '') : '');
    }
  }, [optionValue]);

  return (
    <div className="sticky-resumen mb-30 mt-lg-60 d-none d-lg-block d-xl-block">
      { itemsCart.length > 0
        && dataItemActual
        && dataItemActual.length > 0
        && sessionActive
        ? modalShowCases() : (
          <ModalCheck
            stateInitial={show}
            close={handleClose}
            itemsCart={dataItemActual}
            path="mis-experiencias" />
        ) }
      { stockValidation < 5 ? <CardStockComp /> : '' }
      <div className="card-main bg-color-westar p-15">
        <h2 className="text-tangaroa">{`${(Number(points)).toLocaleString('es-MX')} Puntos Aeroméxico Rewards`}</h2>
        <h3 className="py-15 text-tangaroa text-normal">Tu Experiencia Aeroméxico Rewards</h3>
        {/* eslint-disable react/jsx-props-no-spreading */}
        <Form onSubmit={handleSubmit(onSubmit)}>
          <label htmlFor="select-start">Fecha</label>
          <select
            {...register('startDelivery', { required: true })}
            className="custom-select select-start not-pointer"
            id="select-start"
            readOnly
            defaultValue={startDelivery}>
            <option value="">Selecciona la fecha</option>
            <option value={startDelivery} defaultValue>{moment(startDelivery).format('DD/MM/YYYY')}</option>
          </select>
          <div className="custom-select-cp pb-30">
            <label htmlFor="select-end">Experiencia</label>
            <select
              {...register('selectedMenuId', { 
                required: true,
                onChange: (e) => {
                  setOptionDef(e.target.value);
                  setFlag(false);
                  setSelectName(e.target.options[e.target.selectedIndex].text);
                },
              })}
              id="select-end"
              className="custom-select options"
              defaultValue={flag ? optionValue : optionDef}>
              <option value="" defaultValue>Elige</option>
              {
                /* eslint-disable */
                options.map((opt, index) => {
                  if (options.length === 1) {
                    return <option value={opt.id} key={index} selected>{opt.title}</option>
                  }
                  return <option value={opt.id} key={index}>{opt.title}</option>
                })
              }
            </select>
            {errors.selectedMenuId?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
          </div>
          <label htmlFor="count-input">¿Cuántas Experiencias quieres adquirir?</label>
          <Row className="input-count pb-3">
            <Col xs={3} className="pr-0">
              <button type="button" className="btn-form btn-right" onClick={handleLess}>-</button>
            </Col>
            <Col xs={6} className="px-0">
              <input
                {...register('count', {
                  required: true,
                  min: 1,
                  max: stockValidation,
                  onChange: e => setCount(e.target.value.replace(new RegExp(/[^\d]/,'ig'), '')),
                })}
                value={count}
                id="count"
                name="count"
                placeholder="0"
                className="count-input"
                type="text" />
            </Col>
            <Col xs={3} className="pl-0">
              <button type="button" className="btn-form btn-left" onClick={handlePlus}>+</button>
            </Col>
            <Col lg={10}>
              {errors.count?.type === 'required' && <small className="error-msg">* Campo requerido</small>}
              {errors.count?.type === 'min' && <small className="error-msg">* El mínimo de compra es 1</small>}
              {errors.count?.type === 'max' && <small className="error-msg">{`* El límite del stock es: ${stockValidation}`}</small>}
            </Col>
          </Row>
          <Row>
            <div className="custom-control custom-checkbox pl-5">
              <input
                id="check"
                className="custom-control-input"
                type="checkbox"
                onChange={() => setIsCheckedYouMustKnow(!isCheckedYouMustKnow)} />
              <label htmlFor="check" className="custom-control-label text-tangaroa">
                <p className="ft-12 text-tangaroa font-weight-normal mb-2">
                  Acepto que he leído el apartado <HashLink to={`/${pathName}/${pathId}#experience-info`} className="link">‘Lo que debes saber’</HashLink> de esta Experiencia
                </p>
              </label>
            </div>
          </Row>
          <button
            type="submit"
            className="btn btn-primary w-100"
            disabled={stockValidation === 0 || !isCheckedYouMustKnow}>
            Agregar al carrito
          </button>
        </Form>
      </div>
    </div>
  );
};

TypeFaceToFace.propTypes = {
  details: PropTypes.object.isRequired,
  points: PropTypes.number.isRequired,
  optionValue: PropTypes.any,
  cards: PropTypes.array.isRequired,
};

export default TypeFaceToFace;
